import { MAP_TYPES } from "@deck.gl/carto";
import { CONNECTION } from "../config.js";

const SOURCE_ID = "source";
const source = {
  id: SOURCE_ID,
  connection: CONNECTION.connection,
  data: `SELECT geom, day_of_week, part_of_day, n_visitors FROM ${CONNECTION.project}.${CONNECTION.dataset}.${CONNECTION.table_wide} `,
  type: MAP_TYPES.QUERY,
};

export default source;
